import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import TopicCoverageSelectionContainer from './TopicCoverageSelectionContainer';
import {CallConditionType, SpeakerCondition} from 'records/CallTrigger';
import FilterWordsStore from 'stores/triggers/FilterWordsStore';
import FilterWordsActions from 'actions/triggers/FilterWordsActions';

@connectToStores
export default class TopicCoverageSelectionViewRow extends React.Component {
  constructor(props) {
    super(props);

    this.showSelection = this.showSelection.bind(this);
    this.closeSelection = this.closeSelection.bind(this);
    this.saveSelection = this.saveSelection.bind(this);

    this.state = {
      selectionVisible: false,
      previousContext: null,
    };
  }

  componentDidMount() {
    const filterWordsLoaded = FilterWordsStore.getState().filterWordsLoaded;
    if (!filterWordsLoaded) {
      FilterWordsActions.fetchAll.defer();
    }
    if (this.props.context) {
      this.setState({previousContext: this.props.context});
    }
  }

  static getStores() {
    return [FilterWordsStore];
  }

  static getPropsFromStores(nextProps) {
    const {context} = nextProps;
    if (context) {
      const filterWords = FilterWordsStore.getState().filterWords;
      const filterWord =
        context.keywordTopicPhrase &&
        filterWords.find(w => w.id === context.keywordTopicPhrase.filterWordId);
      return {
        filterWord,
      };
    }

    return null;
  }

  showSelection() {
    this.setState({
      selectionVisible: true,
    });
  }

  closeSelection() {
    this.setState({
      selectionVisible: false,
    });
    this.state.previousContext && this.props.updateContext(this.state.previousContext);
  }

  saveSelection(context, close = true) {
    if (close) {
      this.setState({
        selectionVisible: false,
        previousContext: context,
      });
    }
    this.props.updateContext && this.props.updateContext(context);
  }

  renderDescription(context, filterWord, defaultText) {
    if (context && context.range === undefined) {
      return <span>{defaultText}</span>;
    }

    return (
      <span className="condition-action" onClick={this.showSelection}>
        {context.negated && 'not '}
        {context.range && context.range.start === context.range.end
          ? `${context.range.start}% of the `
          : `between ${context.range.start}% and ${context.range.end}% of `}
        {context.speakerType === SpeakerCondition.EXTERNAL &&
          "the contacts' transcript is identified as "}
        {context.speakerType === SpeakerCondition.INTERNAL &&
          "the caller's party's transcript is identified as "}
        {context.speakerType === SpeakerCondition.CALLER &&
          "the caller's transcript is identified as  "}
        {!context.speakerType && "either party's transcript is identified as "}
        {context.type === CallConditionType.TOPIC_COVERAGE &&
          ((filterWord && filterWord.word) || '[SELECT TOPIC]')}
      </span>
    );
  }

  render() {
    const {context, filterWord, defaultText} = this.props;

    return (
      <div>
        {this.renderDescription(context, filterWord, defaultText)}
        {this.state.selectionVisible && (
          <div className="create-rule-popout edit-popout">
            <TopicCoverageSelectionContainer
              saveSelection={this.saveSelection}
              updateSelection={context => this.saveSelection(context, false)}
              saveOnSelect={false}
              closeRequest={this.closeSelection}
              condition={context}
            />
          </div>
        )}
      </div>
    );
  }
}
